import { FC, ReactNode } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children?: ReactNode;
  container?: HTMLElement;
}

const Portal: FC<PortalProps> = (props) => {
  const { children, container = document.body } = props;
  return <div>{createPortal(children, container)}</div>;
};

export default Portal;
